import { ProfessionalProfileService } from '@/api/services/ProfessionalProfile';
import { useServiceInstance } from '@/hooks/useServiceInstance';

import { useServiceMethod } from '../useServiceMethod';

export function useGetProfessional() {
  const service = useServiceInstance(ProfessionalProfileService);
  return useServiceMethod(service.execute);
}
